import type { FC } from "react";
import styled from "@emotion/styled";
import {
  MDSButton,
  MDSButtonIcon,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
} from "@/mds";
import { MdsIconKind } from "@/design-system/components/icon";
import { HeadsUpStateText, StateWrapper } from "./shared";

interface Props {
  message?: string | null;
  onRetry?: () => void;
}

export const HeadsUpErrorView: FC<Props> = ({ message, onRetry }) => {
  return (
    <StateWrapper>
      <HeadsUpStateText as="p">Unable to load Heads Up</HeadsUpStateText>
      {message ? (
        <MessageText as="p" color={MDSTextColor.Secondary} variant={MDSTextVariant.TextXs}>
          {message}
        </MessageText>
      ) : null}
      {onRetry ? (
        <RetryButton variant={MDSButtonVariant.Default} onClick={onRetry}>
          <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={MdsIconKind.RotateRight} />
          Retry
        </RetryButton>
      ) : null}
    </StateWrapper>
  );
};

const MessageText = styled(MDSText)`
  margin-top: 8px;
  margin-bottom: 8px;
`;

const RetryButton = styled(MDSButton)`
  min-width: 120px;
`;
